import { render } from "./ProductionTimeline.vue?vue&type=template&id=5345fa3e&scoped=true"
import script from "./ProductionTimeline.vue?vue&type=script&lang=js"
export * from "./ProductionTimeline.vue?vue&type=script&lang=js"

import "./ProductionTimeline.vue?vue&type=style&index=0&id=5345fa3e&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5345fa3e"]])

export default __exports__